import { GET_BEE_CUSTOM_FONTS_URL } from 'api/TemplateEditAPI';
import { CustomFont } from 'modules/templateEditor/context/ContentEditorPreferencesContext';
import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api';

/**
 * @see - `useQueryBeeCustomFonts` and `useRestQuery` for more information.
 */
export const GET_BEE_CUSTOM_FONTS_CACHE_KEY = [GET_BEE_CUSTOM_FONTS_URL, undefined] as const;

export const sortByFontName = (a: CustomFont, b: CustomFont) => {
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }
  return 0;
};

type QueryBeeCustomFontsResponse = {
  fonts: CustomFont[];
};

export const useQueryBeeCustomFonts = (
  options?: RestQueryHookOptions<QueryBeeCustomFontsResponse>,
) => {
  const {
    data,
    refetch,
    error,
    isError: hasError,
    isLoading,
    isFetching,
  } = useRestQuery<QueryBeeCustomFontsResponse>(GET_BEE_CUSTOM_FONTS_URL, undefined, {
    ...options,
  });

  const customFonts = data?.fonts.sort(sortByFontName) ?? [];

  return { isLoading, isFetching, customFonts, hasError, error, refetch };
};
